import React, { createContext, useContext, useState } from "react";

const MyContext = createContext();

export const useMyContext = () => useContext(MyContext);

export const MyContextProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [taxPercentage,setTaxPercentage]=useState()
  const [book,setBook]=useState([])
  return (
    <>
      <MyContext.Provider value={{cartItems,setCartItems,taxPercentage,setTaxPercentage,book,setBook}}>{children}</MyContext.Provider>
    </>
  );
};